// Contact.js
import React, { useEffect, useRef, useState } from "react";
import styles from "../styles/Contact.module.css";

function MapSection() {
  const [loadMap, setLoadMap] = useState(false);
  const mapRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setLoadMap(true);
          observer.disconnect();
        }
      },
      { rootMargin: "200px" }
    );

    if (mapRef.current) observer.observe(mapRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <div ref={mapRef} className={styles.mapWrapper}>
      {loadMap ? (
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3072.7392692983776!2d19.877729176743536!3d39.63307410296117!2m3!1f0!3f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x135b5d49106383a7%3A0x626d551ba8813eb!2sNADALI%20COFFEE%20%26%20BAKERY!5e0!3m2!1sen!2sgr!4v1770757914054!5m2!1sen!2sgr"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          loading="lazy"
          title="Nadali Location"
        />
      ) : (
        <div className={styles.mapPlaceholder}>Loading map...</div>
      )}
    </div>
  );
}

export default function Contact() {
  return (
    <section className={styles.contactSection}>
      <div className={styles.container}>
        <h1>Contact Us</h1>
        <p className={styles.subtitle}>
          We'd love to hear from you. Whether you're craving a perfect coffee,
          have a question, or just want to say hello — we're here for you.
        </p>

        <div className={styles.grid}>
          <div className={styles.info}>
            <h3>Visit Us</h3>
            <p>
              Experience freshly brewed coffee, warm pastries, and a welcoming
              atmosphere in the heart of Corfu.
            </p>

            <div className={styles.item}>
              <strong>📍 Location</strong>
              <p>Corfu, Greece</p>
            </div>

            <div className={styles.item}>
              <strong>📞 Phone</strong>
              <a href="tel:+302661048858">+30 26610 48858</a>
            </div>

            <div className={styles.item}>
              <strong>📸 Instagram</strong>
              <a
                href="https://www.instagram.com/nadalicoffeebakery/"
                target="_blank"
                rel="noreferrer"
              >
                @nadalicoffeebakery
              </a>
            </div>
          </div>

          <div className={styles.map}>
            <MapSection />
          </div>
        </div>
      </div>
    </section>
  );
}
